import Tooltip from '@mui/material/Tooltip';
export default Tooltip;
